<!-- eslint-disable -->
<template lang="pug">
    .olympiad-result-page
        .olympiad-result-page__block(v-if="!isLoading && olympiad")
            olympiad-box(:backgroundTop="false")
                template(slot="top")
                    olympiad-preview(:olympiad="olympiad")
                        span(v-text="$i18n.t('olympiads.olympiads_resultPage_congratulationsToTheWinners')")
                    .olympiad-result-page__buttons-container(v-show="olympiad")
                        a(target="_blank", :href="excelExportUrl")
                            cs-button.olympiad-result-page__button(
                                v-if="user.isSuperadmin || user.type === 'admin'",
                                narrow,
                                color="blue",
                                pattern="primary-outline"
                            )
                                svg-icon(name="tablet", width="20" height="20")
                                | {{ $i18n.t('olympiads.olympiads_resultPage_openWithExcel') }}
                        cs-button.olympiad-result-page__button(
                            v-if="user.isSuperadmin",
                            narrow,
                            color="blue",
                            pattern="primary-outline"
                            @click="toOlympiad"
                        )
                            | {{ $i18n.t('points.points_preview_olympiad') }}
                    result-students-list.olympiad-result-page__list(
                        v-for="level in olympiad.levels",
                        :key="level.id",
                        :students="level.registeredUsers",
                        :header="`Тема «${level.theme}»`"
                    )
            .olympiad-result-page__exit-button
                router-link(:to="{name: 'dashboard'}")
                    cs-button(color="white" pattern="primary")
                        | {{ $i18n.t('common.common_navigation_exit') }}
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import OlympiadBox from './Box.vue';
    import Decorations from './Decorations.vue';
    import ResultStudentsList from './ResultStudentsList.vue';
    import OlympiadPreview from './PreviewWithDecorations.vue';
    import OlympiadApi from "../../api/olympiad";
    import _ from 'lodash';
    import {mapState} from 'vuex';

    export default {
        props: ['id'],
        data() {
            return {
                olympiad: null,
                isLoading: false
            }
        },
        mounted () {
            this.isLoading = true;
            OlympiadApi.results(this.id)
            .then(olympiad => {
                olympiad.levels.forEach(level => {
                    level.registeredUsers.forEach(user => {
                        user.pivot.points = +user.pivot.points;
                    });
                });
                this.olympiad = olympiad;
                this.isLoading = false;
            })
            .catch(() => {
                this.isLoading = false;
                this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
            });
        },
        methods: {
            toOlympiad() {
                this.$router.push({name: 'olympiads:show', params: {id: this.olympiad.id}});
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            excelExportUrl() {
                return '/api/olympiad-results/' + this.olympiad.id + '/export';
            }
        },
        components: {
            ResultStudentsList,
            OlympiadBox,
            Decorations,
            OlympiadPreview,
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-result-page {
        margin: 0 auto;
        @include media($lg) {
            width: 80%;
        }
        @include media($xxl) {
            width: 70%;
        }
    }

    .olympiad-result-page__exit-button {
        text-align: center;
    }

    .olympiad-result-page__buttons-container {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }

    .olympiad-result-page__button {
        font-weight: 500 !important;
        .svg-icon {
            margin-right: 5px;
        }
    }
</style>
